import { activePost } from '../utils/request';

const DoubleShareActivity = {};

// 判断用户是否为已注册过-微信
DoubleShareActivity.checkUserByWxcode = (params) => {
    return activePost('/user/check_user_by_wxcode', params);
};
// 立即体验
DoubleShareActivity.shareWxInite = (params) => {
    return activePost('/share/change_wx_invite', params);
};

// 202210 双环共享 加入共享
DoubleShareActivity.addDbclock = (params) => {
    return activePost('/apis/join_dbclock', params);
};

DoubleShareActivity.getDbclockShare = (params) => {
    return activePost('/apis/get_dbclock_share_detail', params);
};

export default DoubleShareActivity;